import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VirtualListComponent} from './views/virtual-list/virtual-list.component';
import {ListItemDirective} from './directives/list-item.directive';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {RippleModule} from 'primeng/ripple';


@NgModule({
  declarations: [
    VirtualListComponent,
    ListItemDirective,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    RippleModule,
  ],
  exports: [
    VirtualListComponent,
    ListItemDirective,
  ]
})
export class VirtualScrollModule {
}
